import { render, staticRenderFns } from "./ModalNovoErp.vue?vue&type=template&id=aec1294e&scoped=true"
import script from "./ModalNovoErp.vue?vue&type=script&lang=js"
export * from "./ModalNovoErp.vue?vue&type=script&lang=js"
import style0 from "./ModalNovoErp.vue?vue&type=style&index=0&id=aec1294e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec1294e",
  null
  
)

export default component.exports